import dayjs from 'dayjs';
import { Table, Pagination, notification, Empty } from "antd";
import { useEffect, useState } from "react";
import { getDeviceCertificate } from "../../axios/api.device";

import { useTranslation } from "react-i18next";

const { Column } = Table;

interface propsModel {
    datas: any;
    id: string;
}

export const DeviceDetailCertificate = (props: propsModel) => {
  const { datas, id } = props;
  const [data, setData] = useState<any[]>();
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);

  const { t } = useTranslation();
  
  useEffect(() => { if (id) { getData(); }}, []);

  const getData = (index = pageIndex, size = pageSize) => {
    getDeviceCertificate(id, { pageIndex: index, pageSize: size }).then(
      (res) => {
        setPageIndex(res.pageIndex);
        setPageSize(res.pageSize);
        setData(res.dataList);
        setTotalCount(res.totalCount);
      },
      (e) => {
        notification.error({ message: e.message })
      }
    );
  };

  return (
    <>
      <Table 
        dataSource={data} 
        rowKey={record => record.certId} 
        pagination={false} 
        size="small"
        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
      >
        <Column title={t("证书名称")} key="name" dataIndex="name"></Column>
        <Column 
          title={t("是否有密码")} key="isHasPassword" dataIndex="isHasPassword" 
          render={v => v ? t("是") : t("否")}
        ></Column>
        <Column 
          title={t("到期日")} key="expireDate" dataIndex="expireDate" 
          render={v => dayjs(new Date(v)).format("YYYY/MM/DD")}
        ></Column>
      </Table>
      <Pagination
        style={{ textAlign: "right", marginTop: "20px" }}
        pageSize={pageSize}
        current={pageIndex}
        total={totalCount}
        showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
        onChange={(page, pageSize) => getData(page, pageSize) }
        onShowSizeChange={(current, size) => getData(current, size)}
      ></Pagination>
    </>
  );
};
